import { render, staticRenderFns } from "./show-team-task.vue?vue&type=template&id=4bb095fb&scoped=true&"
import script from "./show-team-task.vue?vue&type=script&lang=js&"
export * from "./show-team-task.vue?vue&type=script&lang=js&"
import style0 from "./show-team-task.vue?vue&type=style&index=0&id=4bb095fb&lang=scss&scoped=true&"
import style1 from "./show-team-task.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb095fb",
  null
  
)

export default component.exports